import { render, staticRenderFns } from "./ArticlesKeywords.vue?vue&type=template&id=880d8bda&scoped=true"
import script from "./ArticlesKeywords.vue?vue&type=script&lang=js"
export * from "./ArticlesKeywords.vue?vue&type=script&lang=js"
import style0 from "./ArticlesKeywords.vue?vue&type=style&index=0&id=880d8bda&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "880d8bda",
  null
  
)

export default component.exports
import QPage from 'quasar/src/components/page/QPage.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QPage,QBtn,QIcon,QInput,QCard,QTd,QTooltip,QDialog});
